import { Navigate, Outlet, useLocation, matchPath } from "react-router-dom";
import { Locations, Roles } from "interfaces/enums";
import { useGetUserQuery } from "api/institutional/user_api";
import { MainLoader } from "@/components/Shared/MainLoader";
import {
  AdminMenuOptions,
  MenuOptions,
} from "../NavSidebarIconMenu/MenuOptions";

export const RoutesPermissions = () => {
  const { data: user, isLoading } = useGetUserQuery({});

  const pathname = useLocation().pathname as Locations;

  if (isLoading) {
    return <MainLoader />;
  }

  const { role, showTo } =
    [...MenuOptions, ...AdminMenuOptions].find((o) =>
      matchPath(o.route, pathname),
    ) || {};

  if (!user) return <Outlet />;

  if (role && role === Roles.admin && !user.is_admin) {
    return <Navigate to={Locations["/"]} />;
  }

  if (role && role === Roles.admin && user.is_admin) {
    return <Outlet />;
  }

  if (user.flags.some((flag) => showTo?.includes(flag))) {
    return <Outlet />;
  }

  if (user.isSuperBroker)
    return <Navigate to={Locations["/ccy-conversion/orders"]} />;

  if (user.isRouterUser || user.isRouterBroker)
    return <Navigate to={Locations["/ccy-conversion/place-order"]} />;

  if (!role)
    return (
      <div
        className="w-full bg-fixed h-screen "
        style={{
          background: "url(/images/background.png)",
          backgroundPosition: "center",
        }}
      ></div>
    );

  return <Navigate to={Locations["/access-denied"]} />;
};

export default RoutesPermissions;
